import React from 'react';
import classNames from 'classnames';

import { search } from './styles.module.css';

// Pass through props so clients can more easily set callbacks, such as onMouseEnter.
// Add info to passed in className so general search icon styling is not overriden.
const SearchIcon = (props) => (
  <span {...props} className={classNames(search, props.className)} />
);

export default SearchIcon;
